import React, { Component, PureComponent, Fragment } from 'react'
import { fromJS, Map, List } from 'immutable'
import { Form, Icon, Dimmer, Loader } from 'semantic-ui-react'

let wait = fn => {
  let threshhold = 300
  let deferTimer = undefined

  return function () {
    let args = arguments
    if (deferTimer) clearTimeout(deferTimer)

    deferTimer = setTimeout(function () {
      fn.apply(this, args)
    }, threshhold)
  }
}

export default class MapField extends Component {
  state = {
    loading: false,
    searchLoading: false,
    search: '',
    searchList: List(),
  }

  getValue = () =>
    Map.isMap(this.props.value)
      ? this.props.value
      : Map({
          lat: 60.170008,
          lng: 24.93837,
          zoom: 12,
        })

  handleSearch = search => {
    this.setState({ searchLoading: true, search })
    this.startSearch(() => this.fetchAddresses(search))
  }

  startSearch = wait(start => start())

  fetchAddresses = address => {
    if (!address) return this.setState({ searchLoading: false })

    let autocomplete = new google.maps.places.AutocompleteService()
    autocomplete.getQueryPredictions({ input: address }, (predictions, status) => {
      this.setState({ searchLoading: false, searchList: fromJS(predictions || []) })
    })
  }

  componentDidMount() {
    let value = this.getValue()
    let { name, onChange } = this.props

    this.map = new google.maps.Map(this._root, {
      center: value.toJS(),
      zoom: 12,
      disableDefaultUI: true,
      zoomControl: true,
      scrollwheel: false,
    })

    this.marker = new google.maps.Marker({
      position: value.toJS(),
      map: this.map,
      draggable: true,
    })

    google.maps.event.addListener(this.marker, 'dragend', ({ latLng }) => {
      this.setState({ loading: true }, () => {
        let geocoder = new google.maps.Geocoder()
        let lat = latLng.lat()
        let lng = latLng.lng()
        geocoder.geocode({ location: { lat, lng } }, results => {
          let address = `Lat: ${lat} Lng: ${lng}`
          let [{ formatted_address = false } = {}] = results
          if (formatted_address) address = formatted_address

          onChange({ name, value: Map({ lat, lng, address, info: this.getValue().get('info', '') }) })
          this.setState({ loading: false })
          this.map.setCenter(new google.maps.LatLng(lat, lng))
        })
      })
    })
  }

  handleItemChange = item => {
    let { name, onChange } = this.props

    this.setState({ loading: true }, () => {
      let geocoder = new google.maps.Geocoder()
      geocoder.geocode({ placeId: item.get('place_id') }, results => {
        let address = item.get('description')

        let [{ formatted_address = false, geometry: { location } = {} } = {}] = results
        let lat = location.lat()
        let lng = location.lng()
        if (formatted_address) address = formatted_address

        onChange({ name, value: Map({ lat, lng, address, info: this.getValue().get('info', '') }) })
        this.setState({ loading: false, search: '', searchList: List() })
        let position = new google.maps.LatLng(lat, lng)
        this.map.setCenter(position)
        this.marker.setPosition(position)
      })
    })
  }

  render() {
    let { loading, search, searchLoading, searchList } = this.state
    let { name, onChange } = this.props
    let value = this.getValue()

    let classes = ['form-input', 'form-input--map', 'form-map']
    if (loading) classes.push('form-map--loading')

    let address = value.get('address')

    return (
      <div className={classes.join(' ')}>
        <div className="form-map-wrapper">
          <div className="form-map-info">
            <div className="form-map-info-address">
              <b>Valittu osoite:</b>{' '}
              {address ? (
                <Fragment>
                  <div>{address}</div>
                  <div>lat: {value.get('lat')}</div>
                  <div>lng: {value.get('lng')}</div>
                </Fragment>
              ) : (
                <span className="form-map-info-address-placeholder">(Osoitetta ei ole asetettu)</span>
              )}
            </div>
            <div className="form-map-info-description">
              <label htmlFor={`${name}-info`}>Lisätiedot</label>
              <textarea
                name="info"
                id={`${name}-info`}
                value={value.get('info', '')}
                placeholder="Lisätietoja osoitteeseen..."
                onChange={e => onChange({ name, value: value.set('info', e.target.value) })}
              />
            </div>
          </div>
          <div className="form-map-component-wrapper">
            <div className="form-map-input">
              <div className="form-map-input-wrapper">
                <input
                  type="text"
                  placeholder="Hae osoitetta..."
                  value={search}
                  onChange={e => this.handleSearch(e.target.value)}
                />
                <span className="form-map-input-icon">
                  {searchList.size ? (
                    <button onClick={e => e.preventDefault() & this.setState({ searchList: List() })}>
                      <Icon name="times" />
                    </button>
                  ) : (
                    <Icon name={searchLoading ? 'spinner' : 'search'} loading={searchLoading} />
                  )}
                </span>
                {searchList.size ? (
                  <div className="form-map-list">
                    {searchList.map((item, key) => {
                      return (
                        <button key={key} onClick={e => e.preventDefault() & this.handleItemChange(item)}>
                          {item.get('description', '')}
                        </button>
                      )
                    })}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="form-map-loader-wrapper">
              <div className="form-map-component" ref={el => (this._root = el)} />
              <Dimmer active={searchLoading} inverted>
                <Loader />
              </Dimmer>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
